<script>
import { TOKEN_SESSION, USER } from '../stores'
import { createEventDispatcher } from 'svelte';
import { onMount } from 'svelte';
import * as Fx from '../globals/Fx'
import Profile from './Profile.svelte';
    
const dispatch = createEventDispatcher()

onMount (async () => {

})
    
</script>

<div class="main">
    <div class="main-container">
        <div class="logo">
            <img height="45px" src="images/logo-conlus.png" alt="Imagen">
        </div>
        <Profile/>

    </div>

</div>

<style>
    .main {
        display: flex;
        position: fixed;
        top: 0;
        width: 100%;
        background-color: transparent;
        color: rgb(49, 53, 100);
        z-index: 1000;
    }

    .main-container {
        display: flex;
        flex-direction: row;
        background-color: #ffffff;
        border-radius: 10px;
        width: 100%;
        padding: 10px 10px;
        justify-content: space-between;
    }

    .logo {
        padding: 10px;
        display: flex;
        align-items: center;
    }

    @media only screen and (max-width: 380px) {
        .main {
            width: unset;
            padding: unset;
        }
        .main-container {
            border-radius: unset;
            width: 100%;
            padding: 10px unset;
        }
    }
</style>